// extracted by mini-css-extract-plugin
module.exports = {"sign_in_footer":"SignInPage_sign_in_footer__2lL8x","phone_link":"SignInPage_phone_link__2_1Mk","disclosures":"SignInPage_disclosures__U3NM5"};